import type { MonitorCategoryCode, TransportTrackMonitorVo } from "@/api/transportTrackMonitorTypes";

/** 旧版抓拍分类、后端枚举、样式类及颜色的唯一映射。 */
export const CAPTURE_CATEGORY_OPTIONS = [
    { value: "ORDER_NODE" as const, label: "运单节点", color: "#3370ff", className: "orderNode" },
    { value: "WAREHOUSE_STATE" as const, label: "货仓状态", color: "#0bbb7d", className: "cargoState" },
    { value: "CANOPY_STATE" as const, label: "棚架状态", color: "#ff9900", className: "canopyState" },
    { value: "EXCEPTION_EVENT" as const, label: "异常事件", color: "#f14747", className: "abnormalEvent" }
];

/** 历史数据没有业务分类，只用于兼容展示。 */
export const HISTORICAL_CATEGORY_OPTION = {
    value: "history",
    label: "历史记录",
    color: "#8c8c8c",
    className: "history"
} as const;

/** 获取抓拍记录的首个业务分类，保持旧版优先级。 */
export const getCaptureCategoryOption = (record: TransportTrackMonitorVo) =>
    CAPTURE_CATEGORY_OPTIONS.find(option => record.categoryCodes.includes(option.value)) ?? HISTORICAL_CATEGORY_OPTION;

/** 将接口时间转换为旧页使用的秒级文本。 */
export const formatCaptureTime = (value: string | null) => value?.replace("T", " ").replace(/\.\d+$/, "") || "--";

/** 合并同次抓拍的多项原因。 */
export const getCaptureReasons = (record: TransportTrackMonitorVo) =>
    record.reasonItems
        .map(item => item.reasonName)
        .filter(Boolean)
        .join("、") || "--";

/** 旧页位置文本同时包含业务位置与经纬度。 */
export const getCaptureLocation = (record: TransportTrackMonitorVo) => {
    const coordinate =
        Number.isFinite(record.longitude) && Number.isFinite(record.latitude)
            ? `${Math.abs(record.longitude as number).toFixed(2)}°${(record.longitude as number) >= 0 ? "E" : "W"}，${Math.abs(record.latitude as number).toFixed(2)}°${(record.latitude as number) >= 0 ? "N" : "S"}`
            : "";
    return record.shipLocation && coordinate
        ? `${record.shipLocation}（${coordinate}）`
        : record.shipLocation || coordinate || "--";
};

/** 分类筛选的兼容类型。 */
export type CaptureCategoryFilter = "all" | MonitorCategoryCode;
